//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import layout from '~/mixins/layout'

export default {
  mixins: [layout],
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'PageFullVideo',
    },
    titleText: {
      type: String,
      default: '',
    },
    shortDescription: {
      type: String,
      default: '',
    },
    video: {
      type: Object,
      default() {},
    },
    isLandingpage: {
      type: Boolean,
      default: false,
    },
    anchorId: {
      type: Object,
      default: () => {},
    },
    pageId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      videoIsPlaying: false,
      innerWidth: window.innerWidth,
      navScroll: {
        scroll: null,
        width: null,
        bounceWidth: 18,
      },
    }
  },
  computed: {
    embeddedYoutubeUrl() {
      // Transform the YouTube URL into the embedded format
      return this.video && this.video.youtubeVideoLink
        ? this.video.youtubeVideoLink.replace('watch?v=', 'embed/')
        : false
    },
  },
  mounted() {
    if (this.video.image === null || this.video.image === undefined) {
      this.videoIsPlaying = true
    }
  },

  methods: {
    playVideo() {
      this.videoIsPlaying = true
    },
  },
}
